import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { isLoaded, isEmpty } from 'react-redux-firebase';
import { signInProvider } from '../../../redux/actions/authActions';

function ProviderSignIn (props) {
  const auth = useSelector(store => store.firebase.auth);

  const dispatch = useDispatch();

  function loginWithGoogle() {
    dispatch(signInProvider(props.provider));
  }

  return (
    <div>
      <div>
        {
          !isLoaded(auth)
          ? <span>Loading...</span>
          : isEmpty(auth)
            ? <button onClick={loginWithGoogle}>Login With Google</button>
            : <pre>{JSON.stringify(auth, null, 2)}</pre>
        }
      </div>
    </div>
  )
}

ProviderSignIn.propTypes = {
  provider: PropTypes.string.isRequired
}

export default ProviderSignIn;